import email from "email-validator";
import { NO_BIZ } from "MODULES/companies/constants";
import { isEmpty } from "lodash";
import { properCase, toSentence } from "../formatters/text";

export const required = val => (!val && "Required") || undefined;

export const requiredUnlessUploaded = (val, values) =>
  (!values.uploaded && !val && "required") || undefined;

export const requiredAllowZero = val =>
  (!val && val !== 0 && "Required") || undefined;

export const matches = field => (val, values) => {
  if (val !== values[field]) {
    return "Does not match";
  }

  return undefined;
};

export const isValidEmail = val => {
  if (val && val.split(",").some(e => !email.validate(e.trim()))) {
    return "Invalid email address";
  }

  return undefined;
};

export const isNumeric = val => {
  if (val && isNaN(val)) {
    return "Please enter a number";
  }

  return undefined;
};

export const isBool = val => {
  if (![false, true, "false", "true"].includes(val)) {
    return "Required";
  }

  return undefined;
};

export const mustBeOne = val => {
  if (Number(val) === 1) {
    return undefined;
  }

  return "Must equal 1";
};

export const isInteger = val => {
  if (val && !/^\d+$/.test(val)) {
    return "Please enter an integer";
  }

  return undefined;
};

export const lengthIsEqual = gteVal => val => {
  if (val && gteVal !== val.length) {
    return `Character length must equal ${gteVal}`;
  }

  return undefined;
};

export const isGreaterThanOrEqualTo = gteVal => val => {
  if (val && parseFloat(val) < gteVal) {
    return `Please enter a number greater than or equal to ${gteVal}`;
  }

  return undefined;
};

export const isLessThanOrEqualTo = lteVal => val => {
  if (val && parseFloat(val) > lteVal) {
    return `Please enter a number less than or equal to ${lteVal}`;
  }

  return undefined;
};

export const maxLengthOfText = mVal => val => {
  if (val && val.length > mVal) {
    return `Max length is ${mVal}`;
  }

  return undefined;
};

export const isLessThan = lessThanVal => val => {
  if (val && parseFloat(val) >= lessThanVal) {
    return `Please enter a number less than ${lessThanVal}`;
  }

  return undefined;
};

export const isGreaterThan = greaterThanVal => val => {
  if (val && parseFloat(val) <= greaterThanVal) {
    return `Please enter a number greater than ${greaterThanVal}`;
  }

  return undefined;
};

export const isBetween = (min, max) => val => {
  if (val && (parseFloat(val) < min || parseFloat(val) > max)) {
    return `Please enter a number between ${min} and ${max}`;
  }

  return undefined;
};

export const matchesPattern = regex => val => {
  if (val && !regex.test(val)) {
    return "is invalid";
  }

  return undefined;
};

export const requiredIfAnyDefined = (...fields) => (val, values) => {
  if (!val && fields.some(f => values[f])) {
    return "Required";
  }

  return undefined;
};

export const requiredIfFieldGreaterThan = (field, value) => (val, values) => {
  if (!val && values[field] && values[field] > value) {
    return `Required when ${field} is greater than ${value}`;
  }

  return undefined;
};

export const requiresAtLeast = (atLeast = 0, ...fields) => (val, values) => {
  if (
    !(
      fields.filter(f => !(isEmpty(values[f]) && values[f] !== true)).length >=
      atLeast
    )
  ) {
    return `Requires at least ${atLeast} field of ${toSentence(
      fields.map(f => properCase(f)),
      "or"
    )}`;
  }

  return undefined;
};

export const customerRmaRequest = (atLeast = 0, ...fields) => (val, values) => {
  if (
    !(
      fields.filter(f => !(isEmpty(values[f]) && values[f] !== true)).length >=
      atLeast
    )
  ) {
    return `When Customer requests an RMA, at least ${atLeast} of the following fields must be selected: ${toSentence(
      fields.map(f => properCase(f)),
      "or"
    )}`;
  }

  return undefined;
};

export const validateCompanyStatus = company => {
  if (company && company.status === NO_BIZ) return "Invalid Company";
  return undefined;
};

export const includesField = validValues => val => {
  if (!validValues.includes(val)) {
    return `Must have one of ${toSentence(
      validValues.map(f => properCase(f)),
      "or"
    )}`;
  }

  return undefined;
};

export const passFailValidation = val => {
  if (val && Number(val) > 0) {
    return "not allowed on pass / fail part";
  }

  return undefined;
};

export const shipToCompanyIsNoBiz = val => {
  if (val) return "Company is flagged as 'Do Not Do Business'.";

  return undefined;
};



// WEBPACK FOOTER //
// ./app/lib/validation/rules.js